module.exports = __webpack_public_path__ + "img/06.458a2b1b.svg";